<template>
  <div class="configurator full-height">
    <v-container class="full-height configurator-container" fluid>
      <v-row class="button-row mobile-reverse">
        <v-col cols="12" md="6" order="1">
          <level-picker></level-picker>
        </v-col>
        <v-col cols="12" md="6"  order="12" class="button-container">
            <div class="button-back">
              <router-link :to="{ name: 'basic-data' }" class="plain-link">
                <v-icon size="43" color="black"> mdi-chevron-left</v-icon>
                <span class="button-back-text">
                  {{ $t(`general.navigation.buttons.back`) }}
                </span>
              </router-link>
            </div>
          <v-divider
            class="mx-4 invisible-divider"
            vertical
          ></v-divider>
          <div class="button-forward">
            <a v-on:click="nextStepDialog = !nextStepDialog" class="plain-link">
              <span class="button-forward-text">
                {{ $t(`general.navigation.buttons.next`) }}
              </span>
              <v-icon size="43" color="white">mdi-chevron-right</v-icon>
            </a>
          </div>
        </v-col>
      </v-row>
      <v-row class="screen-sized">
        <side-menu 
          v-on:clear-all="clearAll()"
          v-on:insert="mode='insert'"
          v-on:insert-text="mode='insert_text'"
          v-on:delete="mode='delete'"
          v-on:change-text="(value) => gridText = value"
        ></side-menu>
        <div ref="pixiCanvasWrapper" class="configurator-canvas pixiBody">
            <canvas ref="pixiCanvas"></canvas>
        </div>
      </v-row>
    </v-container>
    <v-dialog
        v-model="nextStepDialog"
        width="500"
      >
  
        <v-card>
          <v-card-title class="text-h5 lighten-2 card-title-dialog">
            {{ $t(`configurator.nextStep.dialog.title`) }}
          </v-card-title>
  
          <v-card-text class="dialog-text">
            {{ $t(`configurator.nextStep.dialog.content`) }}
          </v-card-text>

          <v-divider></v-divider>
  
          <v-card-actions class="display-buttons-verticaly">
            <v-btn
              dark
              color="#004996"
              depressed
              @click="nextStepDialog = !nextStepDialog"
            >
              {{ $t(`configurator.nextStep.dialog.controls.no`) }}
            </v-btn>
            <v-spacer class="divider-margin-small"></v-spacer>
            <v-btn
              color="success"
              depressed
              @click="nextStage()"
            >
              {{ $t(`configurator.nextStep.dialog.controls.yes`) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
/* eslint-disable */

import _ from 'lodash';

import SideMenu from '../components/configurator/SideMenu.vue'
import LevelPicker from '../components/configurator/LevelPicker.vue'

import * as PIXI from "pixi.js";
import { Viewport } from "pixi-viewport";
import Point from "@/components/configurator/Editor/lib/Cordinates/Point";
import Size from "@/components/configurator/Editor/lib/Cordinates/Size";
import Bounds from "@/components/configurator/Editor/lib/Cordinates/Bounds";
import Screw from "@/components/configurator/Editor/Element/PixiScrew.js";
import BaseElement from "@/components/configurator/Editor/Element/BaseElement.js";
import settings from "@/components/configurator/Editor/lib/_settings.js";
import constants from "@/components/configurator/Editor/lib/_constants.js";
import router from '../plugins/router';
import { mapGetters } from 'vuex'

let gridBoxSize = settings.scalingFactor;
let overlayShift = settings.spriteOverlay / 2;

let angles = {
  left: 0,
  top: 90,
  right: 180,
  bottom: 270,
};

export default {
  components: {
    SideMenu,
    LevelPicker,
  },
  name: 'configurator',
  ready: function () {},
  data() {
    return {
      currentLevel: 0,
      mode: "insert",
      insertType: "",
      insertColor: "black",
      insertAngle: constants.ORIENTATION_LEFT,
      elementSelected: null,
      specialPartsCurrentLevel: null,
      componentMounted: false,
      gridText: '',
      nextStepDialog: false
    };
  },
  computed: {
    ...mapGetters({
      projectReferenceId: 'projectData/getRefNumber',
    })
  },
  watch: {
    gridText: function (newValue, oldValue) {
      if (this.mode != "insert_text") {
        return
      }
      let text = new PIXI.Text(this.gridText);
      text.updateText()

      this.floatingElement.texture = text.texture; 
      this.floatingElement.setSize(new Size(Math.floor(this.gridText.length / 3), 1));
      return;
    },
    mode: function (newValue, oldValue) {
      if (newValue == "insert_text") {
        let text = new PIXI.Text(this.gridText);
        text.updateText()

        this.floatingElement.texture = text.texture;
        this.floatingElement.setSize(new Size(Math.floor(this.gridText.length / 3), 1));
        return;
      } else if (newValue == "delete") {
        this.floatingElement.texture = PIXI.Texture.from("remove-icon");
        this.floatingElement.setSize(new Size(0.2,0.2));
        return
      }
      this.insertAngle = constants.ORIENTATION_LEFT;
      this.floatingElement.angle = 0;
      this.floatingElement.setSize(this.inventory[this.insertType].size);
      this.floatingElement.connections = this.inventory[this.insertType].connections;
      this.floatingElement.texture = PIXI.Texture.from(
        this.insertType + "-" + this.insertColor
      );
    },
    currentLevel: function (newValue, oldValue) {
      // this.levelElements[newValue].alpha = 1;
      // for (let i = -2; i <= 2; i++) {
      //   if (i < newValue) {
      //     this.levelElements[i].alpha = 0.2 * (i + 3);
      //   } else if (i > newValue) {
      //     this.levelElements[i].alpha = 0;
      //   }
      // }

      this.levelElements[newValue].alpha = 1;
      for (let i = -2; i <= 2; i++) {
        if (i < newValue) {
          this.levelElements[i].alpha = 0.5;
        } else if (i > newValue) {
          this.levelElements[i].alpha = 0.5;
        }
      }
      
    },
    insertType: function (newValue, oldValue) {
      let color = this.insertColor
      if(this.currentElement().type == constants.EXTRA_ELEMENT || this.currentElement().sku.black == 203100) {
         color = "black";
      }

      if (this.currentElement().type == constants.EXTRA_ELEMENT) {
        this.floatingElement.anchor.set(0.5, 0.5);
      } else {
        this.floatingElement.anchor.set(0, 0);
      }

      this.insertAngle = constants.ORIENTATION_LEFT;
      this.floatingElement.angle = 0;
      this.floatingElement.setSize(this.inventory[newValue].size);
      this.floatingElement.connections = this.inventory[newValue].connections;
      this.floatingElement.texture = PIXI.Texture.from(
        newValue + "-" + color
      );
    },
    insertColor: function (newValue, oldValue) {
      if(this.currentElement().type == constants.EXTRA_ELEMENT || this.currentElement().sku.black == 203100) {
        newValue = "black";
      }

      if (this.inventory[this.insertType].type != constants.BASE_ELEMENT && this.inventory[this.insertType].type != constants.CONNECTOR_ELEMENT) {
        return;
      }
      this.floatingElement.texture = PIXI.Texture.from(
        this.insertType + "-" + newValue
      );
    },
    projectReferenceId: function () {
      this.elements = this.$store.getters['projectData/getConfiguration']
      if (!_.isEmpty(this.elements)) {
        this.clearAll();
        this.loadElements();
        this.elements = [];
      }
    }
  },

  baseElementsProducts: {
    count: {},
    elements: {},
    gridSize: {
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
    }
  },

  myBaseElements: null,
  myExtraElements: null,
  myConnectors: null,
  myTextElements: null,

  inventory: null,
  pixiApp: null,
  pixiViewport: null,
  floatingElement: null,
  levelElements: null,

  activated: function() {
    console.log("Activated called");
    // Add basis form element on screen
    
    let edit = this.projectReferenceId != '';

    if (!_.isEmpty(this.elements) && this.componentMounted) {
      this.clearAll();
      this.loadElements(edit);
    }
  },
  mounted() {
    console.log("Starting PIXI application");
    var vm = this;

    this.baseElementsProducts = {
      count: {},
      elements: [],
      gridSize: {
        top: 0,
        bottom: 250,
        right: 0,
        left: 250,
      }
    };

    this.myBaseElements = {
      "-2": {},
      "-1": {},
      0: {},
      1: {},
      2: {},
    };

    this.myExtraElements = {
      "-2": {},
      "-1": {},
      0: {},
      1: {},
      2: {},
    };

    this.myConnectors = {
      "-2": {},
      "-1": {},
      0: {},
      1: {},
      2: {},
    };

    this.myTextElements = {
      "-2": {},
      "-1": {},
      0: {},
      1: {},
      2: {},
    };

    this.inventoryElements = this.$store.getters['api/getInventory'];

    this.inventory = this.inventoryElements.reduce((acc, item) => {
      acc[item.name] = {
        type: item.type,
        ruleset: item.rule,
        size: constants.ELEMENT_SIZES[item.rule],
        sku: item.variations.reduce((acc, item)=>{
          acc[item.color] = item.sku;
          return acc;
        }, {}),
        connections: constants.ELEMENT_CONNECTIONS[item.rule],
      }
      return acc;
    }, {});
    let canvas = this.$refs["pixiCanvas"];
    let canvasWrapper = this.$refs["pixiCanvasWrapper"];

    this.pixiApp = new PIXI.Application({
      backgroundColor: "0xFFFFFF",
      view: canvas,
      resizeTo: canvasWrapper,
      preserveDrawingBuffer: true,
    });

    // create viewport
    this.pixiViewport = new Viewport({
      width: 1024,
      height: 1024,
      worldWidth: gridBoxSize * 500,
      worldHeight: gridBoxSize * 500,
      interaction: this.pixiApp.renderer.plugins.interaction,
      divWheel: canvas,
    });

    let loadingElement = new PIXI.Text("Loading ...", {
      fontFamily: "Arial",
      fontSize: 24,
      fontWeight: "bold",
      align: "center",
    });
    loadingElement.position.set(250 * gridBoxSize, 250 * gridBoxSize)
    vm.pixiViewport.addChild(loadingElement);

    this.levelElements = {
      "-2": new PIXI.Container(),
      "-1": new PIXI.Container(),
      0: new PIXI.Container(),
      1: new PIXI.Container(),
      2: new PIXI.Container(),
    };

    this.pixiViewport
      .drag()
      .pinch()
      .wheel()
      .decelerate()
      .moveCenter(190 * gridBoxSize, 190 * gridBoxSize);
    this.pixiViewport.clampZoom({ minScale: 0.3, maxScale: 1.5 });
    this.pixiViewport.setZoom(0.75);
    this.pixiViewport.clamp({
      left: true,
      top: true,
      right: true,
      bottom: true,
      direction: "all",
    });
    this.pixiApp.stage.addChild(this.pixiViewport);

    this.insertType = this.$store.getters['configurator/getCurrentItem'].item.name;
    this.insertColor = this.$store.getters['configurator/getCurrentItem'].variation.color;
    this.currentLevel = this.$store.getters['configurator/getLevel'];

    vm.floatingElement = new BaseElement(
      null,
      new Point(250, 250),
      vm.inventory[vm.insertType].size,
      vm.inventory[vm.insertType].connections
    );
    vm.floatingElement.alpha = 0.7;

    var loader = new PIXI.Loader();
    for(let i = 0; i<this.inventoryElements.length; i++) {
      let element = this.inventoryElements[i];
      for(let j = 0; j<this.inventoryElements[i].variations.length; j++) {
        let variation = this.inventoryElements[i].variations[j];
        loader.add(element.name + "-" + variation.color, `${process.env.VUE_APP_BACKEND_STORAGE_URL}/${variation.canvas_image}`);
      }
    }
    loader.add(
        "middle-beach",
        "https://thumbs.dreamstime.com/b/aerial-sea-water-waves-beach-texture-background-top-view-aerial-sea-water-waves-beach-texture-background-top-view-149954405.jpg"
      )
      .add("ocean-beach", "https://i.ibb.co/6mF9Vzw/image.png")
      .add("beach-beach", "https://i.ibb.co/Ks9XHsf/image.png")
      .add("text","https://i.ibb.co/8jPZkK3/image.png")
      .add("remove-icon", "https://i.ibb.co/fd3dGzc/Heavy-red-x-removebg-preview.png")
      loader.load(setup);

    function setup() {
      // Add grid on screen
      var n = 500;
      loadingElement.visible = false

      // Backgound images
      for (let j = 0; j < 171; j++) {
        for (let i = 0; i < 43; i++) {
          let middleImage = new PIXI.Sprite();
          middleImage.texture = PIXI.Texture.from("ocean-beach");
          middleImage.position.set(
            i * middleImage.width,
            j * middleImage.height
          );
          middleImage.alpha = 0.4;
          if (j == 170) {
            middleImage.height -= 18;
          }
          vm.pixiViewport.addChild(middleImage);
        }
      }

      for (let i = 0; i < 43; i++) {
        let middleImage = new PIXI.Sprite();
        middleImage.texture = PIXI.Texture.from("middle-beach");
        middleImage.position.set(i * middleImage.width, 246 * gridBoxSize);
        middleImage.alpha = 0.4;
        vm.pixiViewport.addChild(middleImage);
      }

      for (let j = 108; j < 250; j++) {
        for (let i = 0; i < 43; i++) {
          let middleImage = new PIXI.Sprite();
          middleImage.texture = PIXI.Texture.from("beach-beach");
          middleImage.position.set(
            i * middleImage.width,
            j * middleImage.height
          );
          middleImage.alpha = 0.4;
          if (j == 108) {
            middleImage.height += 106;
            middleImage.position.y -= 106;
          }
          vm.pixiViewport.addChild(middleImage);
        }
      }

      // Grid
      let { verticalNumbers, horizontalNumbers, grid } = vm.getGridContainer(
        n,
        gridBoxSize
      );
      vm.pixiViewport.addChild(grid);

      // Add elements placeholder on screen
      vm.pixiViewport.addChild(vm.levelElements[-2]);
      vm.pixiViewport.addChild(vm.levelElements[-1]);
      vm.pixiViewport.addChild(vm.levelElements[0]);
      vm.pixiViewport.addChild(vm.levelElements[1]);
      vm.pixiViewport.addChild(vm.levelElements[2]);

      // Add ruler on screen
      vm.pixiViewport.addChild(horizontalNumbers);
      vm.pixiViewport.addChild(verticalNumbers);

      // Add floating element on screen
      vm.floatingElement.texture = PIXI.Texture.from(
        vm.insertType + "-" + vm.insertColor
      );
      vm.pixiViewport.addChild(vm.floatingElement);
      vm.pixiViewport.on("clicked", onClick);
      document.oncontextmenu = function(e) {e.preventDefault(); vm.rotate();}

      vm.pixiViewport.on("zoomed", () => {
        horizontalNumbers.children.forEach((i) => {
          i.fontSize = 2;
        });
      });

      function onClick(e) {
        var gridCords = vm.getGridCoords(gridBoxSize);
        console.log("clicked on " + gridCords);

        // right click - might also use e.event.data.which
        if (e.event.data.button == 2) {
          return;
        }

        // Check if out of grid
        if (
          gridCords.x < 0 ||
          gridCords.y < 0 ||
          gridCords.x > n - 1 ||
          gridCords.y > n - 1
        ) {
          console.log("click is out of bounds " + gridCords);
          return;
        }
        switch (vm.mode) {
          case "insert_text": {
            vm.addTextElementonGrid(gridCords, vm.currentLevel, vm.gridText);
            break;
          }
          case "insert":
            if (vm.inventory[vm.insertType].type == constants.BASE_ELEMENT) {
              vm.addBaseElementOnGrid(
                gridCords,
                vm.currentLevel,
                vm.insertType,
                vm.insertColor
              );
            } else if (vm.inventory[vm.insertType].type == constants.EXTRA_ELEMENT) {
              vm.addExtraElementOnGrid(
                gridCords,
                vm.currentLevel,
                vm.insertType,
                vm.insertColor,
                vm.insertAngle,
              );
            } else {
              if (gridCords.isIntersection(30)) {
                vm.addConnectorElementOnGrid(
                  gridCords,
                  vm.currentLevel,
                  vm.insertType,
                  vm.insertColor,
                );
              } else {
                console.log("not intersection " + gridCords);
              }
            }
            break;
          case "delete":
            vm.deleteElementOnGrid(gridCords);
            break;
          default:
            console.log("action unknown " + vm.mode);
        }
      }

      vm.elements = vm.$store.getters['projectData/getConfiguration'];

      if (!_.isEmpty(vm.elements)) {
        vm.loadElements(true);
      }
      vm.pixiApp.ticker.add((d) => {
        var currCoords = vm.getGridCoords(gridBoxSize);
        verticalNumbers.position.y = vm.pixiViewport.top + 20;
        horizontalNumbers.position.x = vm.pixiViewport.left + 10;

        vm.currentLevel = vm.$store.getters['configurator/getLevel'];
        vm.insertType = vm.$store.getters['configurator/getCurrentItem'].item.name;
        vm.insertColor = vm.$store.getters['configurator/getCurrentItem'].variation.color;

        if (vm.mode == "insert") {
          vm.floatingElement.visible = true;
          if (vm.inventory[vm.insertType].type == constants.CONNECTOR_ELEMENT) {
            if (currCoords.isIntersection(30)) {
              vm.floatingElement.position.set(
                currCoords.x * gridBoxSize - 20,
                currCoords.y * gridBoxSize - 20
              );            
            }
          } else if (vm.inventory[vm.insertType].ruleset == constants.RULESET_CORNER_BUMPER_1) {
            if (currCoords.isIntersection(50)) {
              vm.floatingElement.position.set(
                currCoords.x * gridBoxSize - 30,
                currCoords.y * gridBoxSize - 30
              );            
            }
          } else {
            vm.floatingElement.position.set(
              currCoords.x * gridBoxSize - overlayShift,
              currCoords.y * gridBoxSize - overlayShift
            );
          }

          if (vm.inventory[vm.insertType].type == constants.EXTRA_ELEMENT) {
            if (
              vm.floatingElement.size.height >= 2 &&
              (vm.insertAngle == constants.ORIENTATION_TOP ||
                vm.insertAngle == constants.ORIENTATION_BOTTOM)
            ) {
              vm.floatingElement.position.x += vm.floatingElement.width - overlayShift;
              switch (vm.inventory[vm.insertType].ruleset) {
                case constants.RULESET_SIDE_BUMPER_3: {
                  vm.floatingElement.position.y += vm.floatingElement.height / 3;
                  break;
                }
                case constants.RULESET_SIDE_BUMPER_4: {
                  vm.floatingElement.position.x += 37;
                  vm.floatingElement.position.y += 147.5 / 2;
                  break;
                }
                case constants.RULESET_SIDE_BUMPER_5: {
                  vm.floatingElement.position.x += 75;
                  vm.floatingElement.position.y += 147.5 / 2;
                  break;
                }
                case constants.RULESET_SIDE_BUMPER_6: {
                  vm.floatingElement.position.x += 110;
                  vm.floatingElement.position.y += 147.5 / 2;
                  break;
                }         
                default: {
                  vm.floatingElement.position.y += vm.floatingElement.height / 4;
                  break
                }
              }
            } else {
              vm.floatingElement.position.x += vm.floatingElement.width / 2;
              vm.floatingElement.position.y += vm.floatingElement.height / 2;
            }
            if (vm.inventory[vm.insertType].ruleset.includes('side_bumper')) {
              vm.floatingElement.position.y -= 25;
            }
          }
        } else if (vm.mode == "delete") {
          vm.floatingElement.position.set(
            currCoords.xPixel - (vm.floatingElement.width / 2),
            currCoords.yPixel - (vm.floatingElement.height / 2)
          );
          return
        } else if (vm.mode == "insert_text") {
          vm.floatingElement.position.set(
            currCoords.x * gridBoxSize - overlayShift,
            currCoords.y * gridBoxSize - overlayShift
          );
          return;
        }

        if (vm.insertType == "steps") {
          return;
        }
        if (
          (vm.myBaseElements[vm.currentLevel][currCoords.getHash()] ||
          vm.myBaseElements[vm.currentLevel][
            currCoords.move(0, vm.floatingElement.size.height - 1).getHash()
          ]) && vm.inventory[vm.insertType].type != constants.CONNECTOR_ELEMENT
        ) {
          // overlaps za seljake
          vm.floatingElement.tint = 0xb22222;
        } else {
          vm.floatingElement.tint = 0xffffff;
        }
      });

      vm.componentMounted = true;
    }
  },
  methods: {
    getGridCoords(boxSize) {
      if (this.pixiApp.renderer.plugins.interaction.eventData.data == null){
        return new Point(0,0);
      }
      var mousePosition = this.pixiViewport.toLocal(
        this.pixiApp.renderer.plugins.interaction.eventData.data.global
      );
      return new Point(
        Math.floor(mousePosition.x / boxSize),
        Math.floor(mousePosition.y / boxSize),
        this.currentLevel,
        mousePosition.x,
        mousePosition.y
      );
    },
    getGridContainer(n, gridBoxSize) {
      var grid = new PIXI.Container();
      grid.name = "grid";
      var line = new PIXI.Graphics();
      line.lineStyle(4, 0xb5aeae, 0.5);
      // Vertical lines
      let verticalNumbers = new PIXI.Container();
      for (var row = 0; row <= n; row++) {
        line.moveTo(row * gridBoxSize, 0);
        line.lineTo(row * gridBoxSize, n * gridBoxSize);
        if (row == n) {
          continue;
        }
        let rowText;
        if (row < n / 2) {
          rowText = n / 4 - row*0.5;
        } else {
          rowText = row*0.5 - n / 4;
        }
        let text = new PIXI.Text(rowText, {
          fontFamily: "Arial",
          fontSize: 24,
          fontWeight: "bold",
          align: "center",
        });
        if (row % 10 == 0) {
          if (row > n / 2) {
            text.text = "R" + text.text;
          } else {
            if (text.text != 0) {
              text.text = "L" + text.text;
            }
          }
        }

        let off = 6;
        switch (text.text.length) {
          case 1:
            off = 6;
            break;
          case 2:
            off = 12;
            break;
          case 3:
            off = 21;
            break;
          case 4:
            off = 30;
            break;
        }
        text.position.set(row * gridBoxSize - off, 0);
        verticalNumbers.addChild(text);
      }
      // Horizontal lines
      let horizontalNumbers = new PIXI.Container();
      for (var col = 0; col <= n; col++) {
        line.moveTo(0, col * gridBoxSize);
        line.lineTo(n * gridBoxSize, col * gridBoxSize);
        if (col == n) {
          continue;
        }
        let colText;
        if (col < n / 2) {
          colText = n / 4 - col*0.5;
        } else {
          colText = col*0.5 - n / 4;
        }
        let text = new PIXI.Text(colText, {
          fontFamily: "Arial",
          fontSize: 24,
          fontWeight: "bold",
          align: "center",
        });
        text.position.set(0, col * gridBoxSize - 15);
        if (col % 10 == 0) {
          if (col > n / 2) {
            text.text = "-" + text.text;
          } else {
            if (text.text != 0) {
              text.text = "+" + text.text;
            }
          }
        }
        horizontalNumbers.addChild(text);
      }
      grid.addChild(line);
      return {
        verticalNumbers,
        horizontalNumbers,
        grid,
      };
    },
    addBaseElementOnGrid(cords, level, type, color, connect = true) {
      if (this.myBaseElements[level][cords.getHash()]) {
        console.log(`element already at ${cords}, level ${level}`);
        return;
      }

      let newBox = new BaseElement(
        PIXI.Texture.from(type + "-" + color),
        cords,
        this.inventory[type].size,
        this.inventory[type].connections
      );
      newBox.position.set(
        cords.x * gridBoxSize - overlayShift,
        cords.y * gridBoxSize - overlayShift
      );

      let overlaps = false;
      let area = new Bounds();
      area.addPoint(cords, newBox.size);
      area.getPoints(level).some((elem) => {
        if (this.myBaseElements[level][elem.getHash()]) {
          overlaps = true;
          return true;
        }
      });

      // Check if element overlaps
      if (overlaps) {
        console.log("element overlaps at " + cords);
        return;
      }

      this.levelElements[level].addChildAt(newBox, 0);

      let newElement = this.addInStore(level, cords, newBox, type, color);

      if (connect) {
        let connections = this.getConnections(
          newElement.element.point,
          newElement.element.size,
          newElement.settings.color,
          newElement.settings.level
        );
        _.forOwn(connections, (elem, id) => {
          // only allow connector binding on element
          let exists = _.find(
            newElement.element.getConnectorPoints(),
            (item) => item.getHash() == elem.cords.getHash()
          );
          if (!exists) {
            return;
          }

          this.addConnectorElementOnGrid(elem.cords, level, elem.settings.type, elem.settings.color, elem);
        });
      }
    },
    addConnectorElementOnGrid(cords, level, type, color, elem) {
      if (cords.getHash() in this.myConnectors[level]) {
        this.levelElements[level].removeChild(
          this.myConnectors[level][cords.getHash()].element
        );
        delete this.myConnectors[level][cords.getHash()];
      }
      let screw = new Screw(type, color);
      screw.point = cords;
      screw.position.set(
        cords.scaled.x - (overlayShift + 5),
        cords.scaled.y - (overlayShift + 5)
      );
      this.levelElements[level].addChild(screw);

      if (!elem) {
        elem = {
          elements: [],
        };
      }
      this.myConnectors[level][cords.getHash()] = {
        element: screw,
        originPoint: cords,
        level: level,
        settings: {
          type: type,
          color: color || 'black',
          sku: this.inventory[type].sku[color || 'black'],
          connector: elem,
        },
      };
    },
    extraElementAllowed(cords, level, ruleset) {
      if (ruleset == constants.RULESET_CORNER_BUMPER_1) {
        if (cords.isIntersection(50)) {
          return true;
        } 
        return false;
      }
      if (ruleset == constants.RULESET_STEPS) {
        if (cords.getHash() in this.myBaseElements[level]) {
          return true;
        }
        return false;
      }
      if (cords.getHash() in this.myBaseElements[level]) {
        console.log(`element already at ${cords}, level ${level}`);
        return false;
      }
      if (
        this.insertAngle == constants.ORIENTATION_TOP ||
        this.insertAngle == constants.ORIENTATION_BOTTOM
      ) {
        if (
          cords.move(-1, 0).getHash() in this.myBaseElements[level] ||
          cords.move(1, 0).getHash() in this.myBaseElements[level] ||
          cords.move(-1, 0).getHash() in this.myExtraElements[level] ||
          cords.move(1, 0).getHash() in this.myExtraElements[level]
        ) {
          console.log(`element too close at ${cords}, level ${level}`);
          return false;
        }
      }
      if (
        this.insertAngle == constants.ORIENTATION_LEFT ||
        this.insertAngle == constants.ORIENTATION_RIGHT
      ) {
        if (
          cords.move(0, -1).getHash() in this.myBaseElements[level] ||
          cords.move(0, 1).getHash() in this.myBaseElements[level] ||
          cords.move(0, -1).getHash() in this.myExtraElements[level] ||
          cords.move(0, 1).getHash() in this.myExtraElements[level]
        ) {
          console.log(`element too close at ${cords}, level ${level}`);
          return false;
        }
      }

      // Check if there is element to pin in on
      let elementCheck = cords;
      switch (this.insertAngle) {
        case constants.ORIENTATION_LEFT:
          elementCheck = cords.move(-1, 0);
          break;
        case constants.ORIENTATION_TOP:
          elementCheck = cords.move(0, -1);
          break;
        case constants.ORIENTATION_RIGHT:
          elementCheck = cords.move(+1, 0);
          break;
        case constants.ORIENTATION_BOTTOM:
          elementCheck = cords.move(0, 1);
          break;
      }

      if (
        !(elementCheck.getHash() in this.myBaseElements[level]) ||
        elementCheck.getHash() in this.myExtraElements[level]
      ) {
        console.log(`no element to pin it on, level ${level}`);
        return;
      }

      return true;
    },
    getExtraConnnections(newElement, ruleset, angle) {
      let elementsArr = [{
        connection: [
            {
              cords: new Point(0, 0),
              level: 3,
              extends: ["rb"],
            },
            {
              cords: new Point(1, 0),
              level: 2,
              extends: ["lb"],
            },
            {
              cords: new Point(0, 1),
              level: 4,
              extends: ["rt"],
            },
            {
              cords: new Point(1, 1),
              level: 1,
              extends: ["lt"],
            },
        ],
      }];
      if (ruleset != "side_bumper" && ruleset.includes("side_bumper") &&  (angle == constants.ORIENTATION_TOP || angle == constants.ORIENTATION_BOTTOM)) {
        let connections = {};
        newElement.element.getConnectorPoints().forEach(elem =>  {
          connections[elem.getHash()] = {
            cords: elem,
            settings: { type: "screw" },
            elements: elementsArr,
          }
        });
        return connections;
      } else if (ruleset == constants.RULESET_STEPS) {
        let connections = {};
        switch (this.insertAngle) {
          case constants.ORIENTATION_LEFT:
            connections[newElement.element.point.move(1, 0).getHash()] = {
              cords: newElement.element.point.move(1, 0),
              settings: { type: "screw" },
              elements: elementsArr,
            };
            connections[newElement.element.point.move(1, 1).getHash()] = {
              cords: newElement.element.point.move(1, 1),
              settings: { type: "screw" },
              elements: elementsArr,
            };
            break;
          case constants.ORIENTATION_TOP:
            connections[newElement.element.point.move(0, 1).getHash()] = {
              cords: newElement.element.point.move(0, 1),
              settings: { type: "screw" },
              elements: elementsArr,
            };
            connections[newElement.element.point.move(1, 1).getHash()] = {
              cords: newElement.element.point.move(1, 1),
              settings: { type: "screw" },
              elements: elementsArr,
            };
            if (
              !(
                newElement.element.point.move(0, 0).getHash() in
                this.myConnectors[this.currentLevel]
              )
            ) {
              connections[newElement.element.point.move(0, 0).getHash()] = {
                cords: newElement.element.point.move(0, 0),
                settings: { type: "screw" },
                elements: elementsArr,
              };
            }
            if (
              !(
                newElement.element.point.move(1, 0).getHash() in
                this.myConnectors[this.currentLevel]
              )
            ) {
              connections[newElement.element.point.move(1, 0).getHash()] = {
                cords: newElement.element.point.move(1, 0),
                settings: { type: "screw" },
                elements: elementsArr,
              };
            }
            break;
          case constants.ORIENTATION_RIGHT:
            connections[newElement.element.point.move(0, 0).getHash()] = {
              cords: newElement.element.point.move(0, 0),
              settings: { type: "screw" },
              elements: elementsArr,
            };
            connections[newElement.element.point.move(0, 1).getHash()] = {
              cords: newElement.element.point.move(0, 1),
              settings: { type: "screw" },
              elements: elementsArr,
            };
            break;
          case constants.ORIENTATION_BOTTOM:
            connections[newElement.element.point.move(0, 0).getHash()] = {
              cords: newElement.element.point.move(0, 0),
              settings: { type: "screw" },
              elements: elementsArr,
            };
            connections[newElement.element.point.move(1, 0).getHash()] = {
              cords: newElement.element.point.move(1, 0),
              settings: { type: "screw" },
              elements: elementsArr,
            };
            if (
              !(
                newElement.element.point.move(0, 1).getHash() in
                this.myConnectors[this.currentLevel]
              )
            ) {
              connections[newElement.element.point.move(0, 1).getHash()] = {
                cords: newElement.element.point.move(0, 1),
                settings: { type: "screw" },
                elements: elementsArr,
              };
            }
            if (
              !(
                newElement.element.point.move(1, 1).getHash() in
                this.myConnectors[this.currentLevel]
              )
            ) {
              connections[newElement.element.point.move(1, 1).getHash()] = {
                cords: newElement.element.point.move(1, 1),
                settings: { type: "screw" },
                elements: elementsArr,
              };
            }
            break;
        }
        return connections;
      }

      return this.getConnections(
        newElement.element.point,
        newElement.element.size,
        newElement.settings.color,
        newElement.settings.level
      );
    },
    addExtraElementOnGrid(cords, level, type, color, angle, checks = true) {
      let inventoryElement = this.inventory[type];

      if (checks && !this.extraElementAllowed(cords, level, inventoryElement.ruleset)) {
        return;
      }

      let xPos = cords.x * gridBoxSize - overlayShift;
      let yPos = cords.y * gridBoxSize - overlayShift;
      if (inventoryElement.ruleset.includes('side_bumper')) {
        yPos -= 25;
      }

      let newBox = new BaseElement(
        PIXI.Texture.from(type + "-black"),
        cords,
        inventoryElement.size,
        inventoryElement.connections
      );
      newBox.anchor.set(0.5, 0.5);
      newBox.angle = angles[angle];

      if (inventoryElement.ruleset == constants.RULESET_CORNER_BUMPER_1) {
        xPos = cords.scaled.x - (overlayShift + 18) 
        yPos = cords.scaled.y - (overlayShift + 18)
      }

      newBox.position.set(xPos, yPos);
        
      if (
        newBox.size.height > 2 &&
        (angle == constants.ORIENTATION_TOP ||
          angle == constants.ORIENTATION_BOTTOM)
      ) {
        switch (inventoryElement.ruleset) {
          case constants.RULESET_SIDE_BUMPER_3: {
            newBox.position.x += 83;
            newBox.position.y += newBox.height / 3;
            break;
          }
          case constants.RULESET_SIDE_BUMPER_4: {
            newBox.position.x += 124;
            newBox.position.y += 147.5 / 2;
            break;
          }
          case constants.RULESET_SIDE_BUMPER_5: {
            newBox.position.x += 160;
            newBox.position.y += 147.5 / 2;
            break;
          }
          case constants.RULESET_SIDE_BUMPER_6: {
            newBox.position.x += 198;
            newBox.position.y += 147.5 / 2;
            break;
          }  
        }
      } else {
        newBox.position.x += newBox.width / 2; // anchor is set at 0.5, 0.5
        newBox.position.y += newBox.height / 2; // anchor is set at 0.5, 0.5
      } 

      this.levelElements[level].addChild(newBox);

      let newElement = this.addInStoreExtra(level, cords, newBox, type, color, this.insertAngle);

      if (
        newBox.size.height > 2 &&
        (angle == constants.ORIENTATION_TOP ||
          angle == constants.ORIENTATION_BOTTOM)
      ) {
        let conns = [];
        for(let i = 0; i < newElement.connections.length; i++) {
          let item = newElement.connections[i];
          let tempX = item.cords.x;
          let tempY = item.cords.y;
          item.cords = new Point(tempY, tempX);
          if (angle == constants.ORIENTATION_TOP && tempX == 0) {
            conns.push(item);
          } else if (angle == constants.ORIENTATION_BOTTOM && tempX == 1) {
            conns.push(item);
          }
        }

        newElement.connections = conns;
        newElement.element.connections = conns;
      }

      if (checks) {
        let connections = this.getExtraConnnections(
          newElement,
          inventoryElement.ruleset,
          angle
        );
        _.forOwn(connections, (elem, id) => {
          // only allow connector binding on element
          let exists = _.find(
            newElement.element.getConnectorPoints(),
            (item) => item.getHash() == elem.cords.getHash()
          );
          if (!exists) {
            return;
          }

          this.addConnectorElementOnGrid(elem.cords, level, elem.settings.type, elem.settings.color, elem);
        });
      }
    },
    addTextElementonGrid(cords,level,text) {
      if (cords.getHash() in this.myTextElements[this.currentLevel]) {
        console.log("text element already exists on this position");
        return;
      }
      if (text == ""){
        return;
      }
      let textElement = new PIXI.Text(text, {
        fontSize: 40,
        align: "center",
      });

      // might want to add custom text element in future (same as BaseElement)
      let size = new Size(Math.floor(this.gridText.length / 3), 1)
      textElement.height = size.scaled.height
      textElement.width = size.scaled.width

      textElement.position.set(
        cords.x * gridBoxSize - overlayShift,
        cords.y * gridBoxSize - overlayShift
      );
      this.levelElements[level].addChild(textElement);

      let payload = {
        element: textElement,
        originPoint: cords,
        level: level,
        text: text,
      };
      this.myTextElements[this.currentLevel][cords.getHash()] = payload;
    },
    addInStore(level, cords, element, type, color) {
      let payload = {
        element: element, // might remove this
        originPoint: element.point,
        connections: element.connections,
        settings: {
          type: type,
          color: color,
          sku: this.inventory[type].sku[color],
          level: level,
        },
      };

      if (this.baseElementsProducts["gridSize"]["top"] < cords.y) { this.baseElementsProducts["gridSize"]["top"] = cords.y }
      if (this.baseElementsProducts["gridSize"]["bottom"] > cords.y) { this.baseElementsProducts["gridSize"]["bottom"] = cords.y }
      if (this.baseElementsProducts["gridSize"]["left"] > cords.x) { this.baseElementsProducts["gridSize"]["left"] = cords.x }
      if (this.baseElementsProducts["gridSize"]["right"] < cords.x) { this.baseElementsProducts["gridSize"]["right"] = cords.x }

      if (!(this.inventory[type].sku[color] in this.baseElementsProducts["count"])) {
        this.baseElementsProducts["count"][this.inventory[type].sku[color]] = 0;
      }
      this.baseElementsProducts["count"][this.inventory[type].sku[color]] += 1; 
      this.baseElementsProducts["elements"].push({
        cords: payload.originPoint,
        level: payload.settings.level,
        type: this.inventory[type].type,
        name: payload.settings.type,
        settings: {
          color: payload.settings.color
        }
      });
      element.size
        .toBounds(cords)
        .getPoints(level)
        .map((elem) => {
            this.myBaseElements[level][elem.getHash()] = payload;
        });
      return payload;
    },
    addInStoreExtra(level, cords, element, type, color, angle) {
      let payload = {
        element: element, // might remove this
        originPoint: element.point,
        connections: element.connections,
        settings: {
          type: type,
          color: color,
          sku: this.inventory[type].sku[color],
          angle: angle,
          level: level,
        },
      };
      element.size
        .toBounds(cords)
        .getPoints(level)
        .forEach((elem) => {
          this.myExtraElements[level][elem.getHash()] = payload;
        });
      return payload;
    },
    removeFromStore(level, cords) {
      if (!(cords.getHash() in this.myBaseElements[level])) {
        console.log("element not in store", cords);
        return;
      }

      let baseElement = this.myBaseElements[level][cords.getHash()];
      this.baseElementsProducts["count"][this.inventory[baseElement.settings.type].sku[baseElement.settings.color]] -= 1; 
      if (this.baseElementsProducts["count"][this.inventory[baseElement.settings.type].sku[baseElement.settings.color]] <= 0) {
        delete this.baseElementsProducts["count"][this.inventory[baseElement.settings.type].sku[baseElement.settings.color]];
      }
       
      this.baseElementsProducts["elements"] = this.baseElementsProducts["elements"].filter(item => item.cords.getHash() !== cords.getHash());

      baseElement.element.size
        .toBounds(cords)
        .getPoints(level)
        .forEach((elem) => {
          delete this.myBaseElements[level][elem.getHash()];
        });
      return baseElement;
    },
    removeFromStoreExtra(level, cords) {
      if (!(cords.getHash() in this.myExtraElements[level])) {
        console.log("element not in store", cords);
        return;
      }

      let baseElement = this.myExtraElements[level][cords.getHash()];
      baseElement.element.size
        .toBounds(cords)
        .getPoints(level)
        .forEach((elem) => {
          delete this.myExtraElements[level][elem.getHash()];
        });
      return baseElement;
    },
    deleteElementOnGrid(mouseCords) {
      // first check if text is to be removed
      if (mouseCords.getHash() in this.myTextElements[this.currentLevel]){
        this.levelElements[this.currentLevel].removeChild(
          this.myTextElements[this.currentLevel][mouseCords.getHash()].element
        );
        delete this.myTextElements[this.currentLevel][mouseCords.getHash()];
        return;
      }

      // second check if screw is to be removed
      if (mouseCords.isIntersection()) {
        if (mouseCords.getHash() in this.myConnectors[this.currentLevel]) {
          this.levelElements[this.currentLevel].removeChild(
            this.myConnectors[this.currentLevel][mouseCords.getHash()].element
          );
          delete this.myConnectors[this.currentLevel][mouseCords.getHash()];
        }
        return;
      }

      // check if click is on element
      if (
        !(mouseCords.getHash() in this.myBaseElements[this.currentLevel]) &&
        !(mouseCords.getHash() in this.myExtraElements[this.currentLevel])
      ) {
        console.log("element does not exist " + mouseCords);
        return;
      }

      let isExtraElement = true;

      let baseElement = this.myExtraElements[this.currentLevel][
        mouseCords.getHash()
      ];
      if (!baseElement) {
        isExtraElement = false;
        baseElement = this.myBaseElements[this.currentLevel][
          mouseCords.getHash()
        ];
      }
      this.levelElements[this.currentLevel].removeChild(baseElement.element);
      if (isExtraElement) {
        this.removeFromStoreExtra(this.currentLevel, baseElement.originPoint);
      } else {
        this.removeFromStore(this.currentLevel, baseElement.originPoint);
      }

      if (baseElement.settings.type == "steps") {
        return;
      }

      let connections = this.getConnections(
        baseElement.element.point,
        baseElement.element.size,
        baseElement.settings.color,
        baseElement.settings.level
      );
      baseElement.element.getConnectorPoints().map((item) => {
        if (
          item.getHash() in this.myConnectors[this.currentLevel] &&
          !(item.getHash() in connections)
        ) {
          this.levelElements[this.currentLevel].removeChild(
            this.myConnectors[this.currentLevel][item.getHash()].element
          );
          delete this.myConnectors[this.currentLevel][item.getHash()];
        } else {
          if (!(item.getHash() in this.myConnectors[this.currentLevel])) {
            return;
          }
          let currType = this.myConnectors[this.currentLevel][item.getHash()].settings.type;
          let newColor = connections[item.getHash()].settings.color;
          let newType = connections[item.getHash()].settings.type;
          if (currType != newType) {
            this.levelElements[this.currentLevel].removeChild(
              this.myConnectors[this.currentLevel][
                item.getHash()
              ].element
            );
            this.addConnectorElementOnGrid(item, this.currentLevel, newType, newColor, connections[item.getHash()]);
          }
        }
      });
    },
    getConnections(point, size, color, level) {
      let connectionPoints = [];
      let neighbourElements = {};

      let b = new Bounds();
      b.addPoint(point.move(-size.width, -size.height), size.resizeBy(2));
      b.getPoints(level).forEach((point) => {
        let elem = this.myBaseElements[this.currentLevel][point.getHash()];
        if (elem) {
          neighbourElements[elem.originPoint.getHash()] = this.myBaseElements[
            this.currentLevel
          ][point.getHash()];
        } else {
          elem = this.myExtraElements[this.currentLevel][point.getHash()];
          if (elem) {
            neighbourElements[
              elem.originPoint.getHash()
            ] = this.myExtraElements[this.currentLevel][point.getHash()];
          }
        }
      });

      // generate new list of connection points
      _.forOwn(neighbourElements, (el, id) => {
        // iterate over all elements
        _.forEach(el.connections, (elConnectionPointSettings) => {
          // iterate over the connection points of one element
          const elConnectionPoint = new Point(
            el.originPoint.x,
            el.originPoint.y,
            this.currentLevel
          ).moveBy(elConnectionPointSettings.cords); // get the absolute cords of the elements connection point

          // try to find if the is already an existing connection point
          let connectionPoint = _.find(
            connectionPoints,
            (connectionPoint) =>
              connectionPoint.cords.x === elConnectionPoint.x &&
              connectionPoint.cords.y === elConnectionPoint.y &&
              connectionPoint.level === this.currentLevel
          );

          // otherwise create a new one
          if (!connectionPoint) {
            connectionPoint = {};
            connectionPoints.push(connectionPoint);

            connectionPoint.cords = elConnectionPoint;
            connectionPoint.level = this.currentLevel;
            connectionPoint.elements = [];
          }

          // and push the current elements connection point into it
          connectionPoint.elements.push({
            element: el,
            connection: elConnectionPointSettings,
          });
        });
      });

      // filter out every point which has just one element attached
      connectionPoints = _.filter(
        connectionPoints,
        (connectionPoint) => connectionPoint.elements.length > 1
      );

      // sanitize connection point settings and update component state
      _.forEach(connectionPoints, (connectionPoint) => {
        if (!connectionPoint.settings) {
          connectionPoint.settings = {};
        }

        if (!connectionPoint.settings.type) {
          connectionPoint.settings.type = "screw";
        }

        const connectionPointExtends = [];
        _.forEach(connectionPoint.elements, (element) => {
          _.forEach(element.connection.extends, (pointExtends) => {
            connectionPointExtends.push(pointExtends);
          });
        });

        if (connectionPointExtends.length >= 4) {
          connectionPoint.settings.type = "bolt";
        } else if (connectionPointExtends.length <= 2) {
          connectionPoint.settings.type = "screw";
        }

        if (
          connectionPoint.settings.type === "bolt" &&
          !connectionPoint.settings.color
        ) {
          connectionPoint.settings.color = color;
        }
      });
      return connectionPoints.reduce((acc, item) => {
        acc[item.cords.getHash()] = item;
        return acc;
      }, {});
    },
    currentElement() {
      return this.inventory[this.insertType];
    },
    rotate() {
      if (this.currentElement().type != constants.EXTRA_ELEMENT) {
        console.log("cannot rotate this element");
        return;
      }

      if (this.floatingElement.angle == 270) {
        this.floatingElement.angle = 0;
      } else {
        this.floatingElement.angle += 90;
      }
      if (this.floatingElement.angle == 0) {
        this.insertAngle = constants.ORIENTATION_LEFT;
      } else if (this.floatingElement.angle % 270 == 0) {
        this.insertAngle = constants.ORIENTATION_BOTTOM;
      } else if (this.floatingElement.angle % 180 == 0) {
        this.insertAngle = constants.ORIENTATION_RIGHT;
        this.floatingElement.x += 50;
      } else if (this.floatingElement.angle % 90 == 0) {
        this.insertAngle = constants.ORIENTATION_TOP;
      }
    },
    count() {
      let elements = {
        ...this.baseElementsProducts.count
      };

      let extraElements = [];
      let connectors = [];
      let textElements = [];
      _.forOwn(this.myExtraElements, (v, level) => {
        _.forOwn(this.myExtraElements[level], (value, key) => {
          if (!value.settings){
            return;
          }
          if (extraElements.filter((i) => { return i.cords.getHash() == value.originPoint.getHash() }).length > 0) {
            // Dedup
            return;
          }
          extraElements.push({
            cords: value.originPoint,
            level: value.settings.level,
            name: value.settings.type, 
            type: constants.EXTRA_ELEMENT,
            settings: {
              color: value.settings.color,
              angle: value.settings.angle,
            }
          });

          if (!elements[value.settings.sku]) {
            elements[value.settings.sku] = 0;
          }
          elements[value.settings.sku] += 1;
        });
      });

      let singleSpacers = 0, doubleSpacers = 0;
      _.forOwn(this.myConnectors, (v, level) => {
        _.forOwn(this.myConnectors[level], (value, key) => {
          if (!value.settings){
            return;
          }
          let connElems = [];
          if (value.settings.connector.elements) {
            connElems = value.settings.connector.elements.map(i => { if (i != null) return i.connection; });
          }
          connectors.push({
            cords: value.originPoint,
            level: value.level,
            name: value.settings.type,
            type: constants.CONNECTOR_ELEMENT,
            settings: {
              color: value.settings.color,
              connector: {
                elements: connElems,
              }
            }
          });
          if (!elements[value.settings.sku]) {
            elements[value.settings.sku] = 0;
          }
          elements[value.settings.sku] += 1;

          if (value.settings.type == "screw") {
            // Only bottom

            // Base elements
            if (!(value.originPoint.move(0,0).getHash() in this.myBaseElements[value.level]) &&
                !(value.originPoint.move(-1,0).getHash() in this.myBaseElements[value.level]) &&
                value.originPoint.move(0,-1).getHash() in this.myBaseElements[value.level] &&
                value.originPoint.move(-1,-1).getHash() in this.myBaseElements[value.level]) {
                  doubleSpacers += 1;
            }

            // Extra elements
            if (!(value.originPoint.move(0,0).getHash() in this.myExtraElements[value.level]) &&
                !(value.originPoint.move(-1,0).getHash() in this.myExtraElements[value.level]) &&
                value.originPoint.move(0,-1).getHash() in this.myExtraElements[value.level] &&
                value.originPoint.move(-1,-1).getHash() in this.myExtraElements[value.level]) {
                  doubleSpacers += 1;
            }

            let num = 0;
            if (value.originPoint.getHash() in this.myBaseElements[value.level]) num+=1;
            if (value.originPoint.move(0,-1).getHash() in this.myBaseElements[value.level]) num+=1;
            if (value.originPoint.move(-1,0).getHash() in this.myBaseElements[value.level]) num+=1;
            if (value.originPoint.move(-1,-1).getHash() in this.myBaseElements[value.level]) num+=1;
            if (value.originPoint.getHash() in this.myExtraElements[value.level]) num+=1;
            if (value.originPoint.move(0,-1).getHash() in this.myExtraElements[value.level]) num+=1;
            if (value.originPoint.move(-1,0).getHash() in this.myExtraElements[value.level]) num+=1;
            if (value.originPoint.move(-1,-1).getHash() in this.myExtraElements[value.level]) num+=1;

            if (num == 3) {
              singleSpacers += 1;
            }
          } else if (value.settings.type == "bolt") {
            if (value.originPoint.move(0,-1).getHash() in this.myBaseElements[value.level]) { 
              let baseElement = this.myBaseElements[value.level][value.originPoint.move(0,-1).getHash()];
              if (baseElement.settings.type == "double") {
                if (value.settings.connector.elements.length == 2 ) {
                  doubleSpacers += 1;
                }
                if (value.settings.connector.elements.length == 3 ) {
                  singleSpacers += 1;
                }
              }
            }
          }
        });
      });

      if (singleSpacers > 0) {
        elements[205000] = singleSpacers;
      }
      
      if (doubleSpacers > 0) {
        elements[205100] = doubleSpacers;
      }

      _.forOwn(this.myTextElements, (v, level) => {
        _.forOwn(this.myTextElements[level], (value, key) => {
          textElements.push({
            cords: value.originPoint,
            level: value.level,
            text: value.text,
            type: constants.TEXT_ELEMENT,
          })
        })
      });

      this.$store.commit('projectData/setConfiguration', this.baseElementsProducts.elements.concat(extraElements).concat(connectors).concat(textElements))
      this.$store.commit('projectData/setProducts', elements)
    },
    clearAll() {
      this.baseElementsProducts = {
        count: {},
        elements: [],
        gridSize: {
          top: 0,
          bottom: 250,
          right: 0,
          left: 250,
        }
      };

      this.myBaseElements = {
        "-2": {},
        "-1": {},
        0: {},
        1: {},
        2: {},
      };

      this.myExtraElements = {
        "-2": {},
        "-1": {},
        0: {},
        1: {},
        2: {},
      };

      this.myConnectors = {
        "-2": {},
        "-1": {},
        0: {},
        1: {},
        2: {},
      };

      this.myTextElements = {
        "-2": {},
        "-1": {},
        0: {},
        1: {},
        2: {},
      };

      this.levelElements[-2].removeChildren();
      this.levelElements[-1].removeChildren();
      this.levelElements[0].removeChildren();
      this.levelElements[1].removeChildren();
      this.levelElements[2].removeChildren();
    },
    loadElements(source = false) {
      let topLevel = -2;
      _.forOwn(this.elements, (el, id) => {
        let cords = el.cords;
        if (el.level > topLevel) {
          topLevel = el.level;
        }
        if (!(el.cords instanceof Point)) {
          cords = new Point(el.cords.x, el.cords.y);
        }
        if (el.type == constants.BASE_ELEMENT) {
          this.addBaseElementOnGrid(
            cords,
            el.level,
            el.name,
            el.settings.color,
            source
          );
        } else if (el.type == constants.EXTRA_ELEMENT) {
          this.addExtraElementOnGrid(
            cords,
            el.level,
            el.name,
            el.settings.color,
            el.settings.angle,
            source,
          );
        } else if (el.type == constants.CONNECTOR_ELEMENT) {
          this.addConnectorElementOnGrid(
            cords, 
            el.level, 
            el.name, 
            el.settings.color,
            el.settings.connector,
          );
        } else if (el.type == constants.TEXT_ELEMENT) {
          this.addTextElementonGrid(
            cords, 
            el.level, 
            el.text
          );
        }
      });
      this.currentLevel = topLevel;
    },  
    screenshot() {
      function b64toBlob(b64Data, contentType, fileName) {
          contentType = contentType || '';
          let sliceSize = 512;

          var byteCharacters = atob(b64Data);
          var byteArrays = [];

          for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
              var slice = byteCharacters.slice(offset, offset + sliceSize);

              var byteNumbers = new Array(slice.length);
              for (var i = 0; i < slice.length; i++) {
                  byteNumbers[i] = slice.charCodeAt(i);
              }

              var byteArray = new Uint8Array(byteNumbers);

              byteArrays.push(byteArray);
          }

        var blob = new Blob(byteArrays, {type: contentType});
        
        var file = new File([blob], fileName, {
          lastModified: new Date(0)
        });
        return file;
      }

      this.levelPictures = [];
      for(let i = -2; i <= 2; i++) {
        if (this.levelElements[i].children.length == 0) {
          continue;
        }
        
        // raise opacity
        let tempAlpha = this.levelElements[i].alpha;
        this.levelElements[i].alpha = 1;

        let localBounds = this.levelElements[i].getLocalBounds();
        let rulerElems = [];
        let count = 0;
        for(let xPos = localBounds.x; xPos < localBounds.x + localBounds.width; xPos += 75) {
          let text = new PIXI.Text(count + "", {
            fontFamily: "Arial",
            fontSize: 15,
            fontWeight: "bold",
            align: "center",
          });
          let offset = 0;
          if ((count + "").length == 1) {
            offset = 10;
          } else if ((count + "").length == 2) {
            offset = 6;
          }
          text.position.set(xPos + offset, localBounds.y + localBounds.height)
          rulerElems.push(text);
          count +=0.5;
        }

        if ((count - 1) * 2 > this.gridWidth) {
          this.gridWidth = (count - 1) * 2;
        }

        count = 0;
        for(let yPos = localBounds.y + localBounds.height; yPos > localBounds.y; yPos -= 75) {
          let text = new PIXI.Text(count + "", {
            fontFamily: "Arial",
            fontSize: 15,
            fontWeight: "bold",
            align: "center",
          });
          text.position.set(localBounds.x - 30, yPos - 22)
          this.levelElements[i].addChild(text);
          rulerElems.push(text);
          count +=0.5;
        }

        if ((count - 1) * 2 > this.gridHeight) {
          this.gridHeight = (count - 1) * 2;
        }

        rulerElems.forEach(el => {
          this.levelElements[i].addChild(el);
        }) 

        let b64Url = this.pixiApp.renderer.plugins.extract.canvas(this.levelElements[i]).toDataURL();
        
        var block = b64Url.split(";");
        var contentType = block[0].split(":")[1];
        var realData = block[1].split(",")[1];

        var blob = b64toBlob(realData, contentType, `level.${i}.png`);
        this.levelPictures.push(blob);

        this.levelElements[i].alpha = tempAlpha;

        rulerElems.forEach(el => {
          this.levelElements[i].removeChild(el);
        });
      }
      this.$store.commit('projectData/setPictures', this.levelPictures)
    },
    nextStage() {
      console.log("Deactivated called");
      this.count();
      this.screenshot();
      router.push({ name: 'project-data' })
    },
  },
}
</script>